import React, { useState } from "react";
import { Card, CardBody, Table, Button } from "reactstrap";
import numberToWords from "../../../../../Components/Common/numberToWords";
import InvoiceBillModal from "./InvoiceBillModal";
import { PrintBill } from "../../../BillPrint/page/PrintBill";

const InvoiceSummary = ({
  orgInfo,
  user,
  selectedTable,
  orderId,
  items,
  calculateTotals,
  paymentStatus,
  selected,
  handleCheckout,
  handleSelect,
  promoSuccess,
  discountAmount,
  selectedPayment,
  selectedCustomer,
  selectedPayments,
  rawOrder,
  isValidAmount,
}) => {
  console.log("🚀 ~ InvoiceSummary ~ items:", items)
  console.log("🚀 ~ InvoiceSummary ~ selectedPayments:", selectedPayments);
  return (
    <div className="sticky-column">
      <Card className="shadow-sm border-0 rounded-3">
        <CardBody
          className="d-flex flex-column p-3 text-level-3"
          style={{ fontFamily: "monospace" }}
        >
          {/* Header */}
          <PrintBill
            currentOrder={items}
            orgInfo={orgInfo}
            user={user}
            orderId={orderId}
            calculateTotals={calculateTotals}
            responseData={rawOrder}
            isestimateprint={true}
            selectedCustomer={selectedCustomer}
          />
          <div className="text-center mb-2">
            <h5 className="fw-bold text-uppercase mb-0 ">
              {orgInfo?.name || "Company Name"}
            </h5>
            <div className="text-uppercase">{orgInfo?.address1 || ""}</div>
            <div>{orgInfo?.tel || "000-0000000"}</div>
            <div className="fw-bold mt-1 text-uppercase text-level-3">
              Provisional Invoice
            </div>
          </div>

          {/* Info Rows */}
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>PAN No.:</strong> {orgInfo?.panNumber || "...."}
            </div>
            <div>
              <strong>Copy of:</strong> Original
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Customer:</strong>{" "}
              {selectedCustomer
                ? `${selectedCustomer.firstName} ${selectedCustomer.lastName}`
                : "...."}
            </div>
            <div>
              <strong>PAN:</strong> {"..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Phone No.:</strong> {selectedCustomer?.phoneNo || "...."}
            </div>
            <div>
              <strong>Cashier:</strong> {user?.name || "..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-1">
            <div>
              <strong>Address:</strong> {selectedCustomer?.address || "...."}
            </div>
            <div>
              <strong>INV No:</strong> {orderId || "..."}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-2">
            <div>
              <strong>Date (B.S.):</strong> 2082/03/26
            </div>
            <div>
              <strong>Date (A.D.):</strong>{" "}
              {new Date().toLocaleDateString("en-GB")}
            </div>
          </div>
          <div className="d-flex justify-content-between small mb-2">
            <div>
              <strong>Table:</strong> {selectedTable?.tableName || "T-1"}
            </div>
            <div>
              <strong>Time:</strong>{" "}
              {new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>

          {/* Table */}
          <Table size="sm" responsive className="table-bordered small mb-0">
            <thead>
              <tr>
                <th>SN</th>
                <th>Item</th>
                <th className="text-center">Qty</th>
                <th className="text-center">Rate</th>
                <th className="text-end">Amnt</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  {item?.complimentaryQuantity > 0 ? (
                    <td className="text-center ">
                      {item?.complimentaryQuantity}
                    </td>
                  ) : (
                    <td className="text-center ">{item?.quantity}</td>
                  )}
                  {/* <td className="text-center">{item.quantity}</td> */}
                  <td className="text-center">{item?.productPrice.toFixed(2)}</td>
                  <td className="text-end">
                    {(item?.productPrice * item?.quantity).toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {/* Totals */}
          <div className="border-top pt-2 small">
            <div className="d-flex justify-content-between">
              <div>Total Qty:</div>
              <div>
                {items.reduce(
                  (total, item) =>
                    total + item.quantity + (item.complimentaryQuantity || 0),
                  0
                )}
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <div>Sub Total:</div>
              <div>Rs. {calculateTotals.subTotal.toFixed(2)}</div>
            </div>
            {/* <div className="d-flex justify-content-between">
              <div>Discount Amount:</div>
              <div>-Rs {calculateTotals.discount.toFixed(2)}</div>
            </div> */}

            {(promoSuccess || discountAmount) && (
              <div className="d-flex justify-content-between">
                <div>Discount Amount:</div>
                <div>Rs {calculateTotals.discount.toFixed(2)}</div>
              </div>
            )}
            <div className="d-flex justify-content-between fw-bold">
              <div>Net Amount:</div>
              <div>Rs. {calculateTotals.total.toFixed(2)}</div>
            </div>
            <div className="mt-2">
              <div>
                <strong>In Words:</strong>{" "}
                {numberToWords(calculateTotals.total)} Rupees
              </div>
            </div>
            <div className="mt-2">
              {/* <div>
                Payment Mode: {selectedPayment?.name} (Rs{" "}
                {calculateTotals.total.toFixed(2)})
              </div> */}
              <div className="mt-2">
                <div>
                  Payment Mode:{" "}
                  {selectedPayments && selectedPayments.length > 0
                    ? selectedPayments.map((p) => p.name).join(", ")
                    : "Not selected"}
                </div>
              </div>
            </div>
            <div className="mt-2">
              <div>Billed by: {user?.name || "Staff"}</div>
            </div>
          </div>

          {/* Footer Info */}
          <div className="small mt-2">
            <div className="text-center mt-2">**Thank You**</div>
            <div className="text-center text-muted small">
              Powered by Restro Order
            </div>
          </div>
        </CardBody>
      </Card>

      <div className="p-3 rounded-3 border-2 shadow-sm bg-white d-flex justify-content-between sticky-bottom align-items-center">
        <div>
          <p className="mb-0 text-muted small">Net sales amount</p>
          <h6 className="fw-bold mb-0 text-success">
            Rs {calculateTotals.total.toFixed(2)}
          </h6>
        </div>
        <Button
          color="success"
          className="px-4 shadow-sm"
          onClick={() => {
            // handleSelect(selected);
            handleCheckout();
          }}
          // disabled={!isValidAmount()}
        >
          Confirm
        </Button>
      </div>

      {/* <InvoiceBillModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        orgInfo={orgInfo}
        user={user}
        selectedTable={selectedTable}
        orderId={orderId}
        items={items}
        calculateTotals={calculateTotals}
        paymentStatus={paymentStatus}
        selected={selected}
      /> */}
    </div>
  );
};

export default InvoiceSummary;
